const instance = process.env.PUBLIC_INSTANCE || '';
const env = process.env.PUBLIC_ENV || '';
const gitRef = process.env.GIT_REF || '';
const commitSha = process.env.COMMIT_SHA || '';

const ref = (gitRef && gitRef !== 'main') ? gitRef : `${instance}-${env}-main`;

export const appVersion = commitSha ? `${ref}-${commitSha}` : ref;
